/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page login
 * @created at      :   2024/10/23
 * @created by      :   ANS902 – quanlh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import repository from './repository';

const dataPassWord = {
    password_old: '',
    password_new: '',
    password_confirm: ''
};
export default {
    namespaced: true,
    state: {
        data: { ...dataPassWord },
        timerHistory: {
            timer_history: []
        },
        currentStatusName: '',
        statusName: '出勤',
        statusDiv: '0'
    },
    mutations: {
        setData(state, data) {
            state.data = data ?? [];
        },
        setStatus(state, payload) {
            state.statusDiv = payload.div;
            state.currentStatusName = payload.currentName;
            state.statusName = payload.name;
        }
    },
    actions: {
        /**
         * change pass word
         * -----------------------------------------
         * @author : quanLh - 2024/07/26 - create
         * @params :
         * @access : private
         */
        changePassWordMNG(context, input) {
            try {
                repository.changePassWordMNG(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message[0]);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        /**
         * change pass word
         * -----------------------------------------
         * @author : quanLh - 2024/07/26 - create
         * @params :
         * @access : private
         */
        changePassWordCUS(context, input) {
            try {
                repository.changePassWordCUS(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onErrorValidate) {
                            input.onErrorValidate(data.Message[0]);
                        }
                    } else {
                        if (input.onError) {
                            input.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
        // getImage(context, rawPath) {
        //     try {
        //         repository.getImage(rawPath).then((res) => {
        //             if (res.status === 200) {
        //                 const imgElement =
        //                     document.querySelector('.user-avatar');
        //                 if (res.data.size > 0) {
        //                     const blob = res.data;
        //                     const objectUrl = URL.createObjectURL(blob);
        //                     imgElement.src = objectUrl;
        //                 }
        //             }
        //         });
        //     } catch (e) {
        //         console.log('Action get image: ' + e.message);
        //     }
        // }
    }
};
